import { SVGProps, Ref, forwardRef } from 'react';

export const HhSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11M9.76 10.122c.577 0 1.05.193 1.383.546.327.347.504.855.504 1.48v3.68H9.983v-3.342c0-.321-.078-.551-.213-.7-.135-.145-.328-.225-.572-.225-.276 0-.53.09-.713.326-.187.235-.312.636-.312 1.262v2.685H6.51V8.197h1.664v2.786c.317-.562.869-.861 1.586-.861m6.407 0c.578 0 1.05.193 1.384.546.327.347.504.855.504 1.48v3.68h-1.664v-3.342c0-.321-.078-.551-.213-.7-.136-.145-.328-.225-.572-.225-.276 0-.53.09-.713.326-.187.235-.312.636-.312 1.262v2.685h-1.664V8.197h1.664v2.786c.317-.562.869-.861 1.586-.861"
            fill="currentColor"
        />
    </svg>
));
HhSolidSize24Glyph.displayName = 'HhSolidSize24Glyph';
